export default __webpack_public_path__ + "static/media/emoji_smile.4324988f.svg";